import React, { useEffect, useState } from "react";
import { TextField } from "@mui/material";
import { SimuladorIncentivoOR } from "./SimuladorIncentivoOR";
import AgricultureIcon from "@mui/icons-material/Agriculture";
import CellTowerIcon from "@mui/icons-material/CellTower";
import GroupWorkIcon from "@mui/icons-material/GroupWork";
import StarsIcon from "@mui/icons-material/Stars";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SimuladorNumericInput from "./SimuladorNumericInput";
import { SimuladorIncentivoAnualOR } from "./SimuladorIncentivosAnualOR";
import BuildIcon from '@mui/icons-material/Build';
import CarRepairIcon from '@mui/icons-material/CarRepair';
import ConstructionIcon from '@mui/icons-material/Construction';
import BathroomIcon from '@mui/icons-material/Bathroom';
import SatelliteAltIcon from '@mui/icons-material/SatelliteAlt';
import { SimuladorIncentivosGerenteOR } from "./SimuladorIncentivosGerenteOR";

const SimuladorIncentivosGerenteScreen = ({ puesto }) => {
    const [formData, setFormData] = useState({
        nombre: "",
        puesto: "",
        fecha: "",
        monto: "",
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const [datos, setDatos] = useState({
        sueldo: 0,
        incentivo: 0,
        ponderacionMaquinaria: 0.20,
        ponderacionRefacciones: 0.15,
        ponderacionServicio: 0.10,
        ponderacionPA: 0.05,
        ponderacionFerreteria: 0.05,
        ponderacionRiego: 0.05,
        ponderacionAMS: 0.05,
        ponderacionDrones: 0.05,
        ponderacionUsados: 0.10,
    });

    const handleChangeDatos = (e) => {
        const { name, value } = e.target;
        setDatos({
            ...datos,
            [name]: value,
        });
    };

    const rangoMaquinaria = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.20 },
        { minimo: 150, maximo: 150000, porcentaje: 0.3 },
    ]

    const rangoRefacciones = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.15 },
        { minimo: 150, maximo: 150000, porcentaje: 0.225 },
    ]

    const rangoServicio = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.10 },
        { minimo: 150, maximo: 150000, porcentaje: 0.15 },
    ]

    const rangoPA = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.05 },
        { minimo: 150, maximo: 150000, porcentaje: 0.075 },
    ]

    const rangoFerreteria = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.05 },
        { minimo: 150, maximo: 150000, porcentaje: 0.075 },
    ]

    const rangoRiego = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.05 },
        { minimo: 150, maximo: 150000, porcentaje: 0.075 },
    ]

    const rangoAMS = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.05 },
        { minimo: 150, maximo: 150000, porcentaje: 0.075 },
    ]

    const rangoDrones = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.05 },
        { minimo: 150, maximo: 150000, porcentaje: 0.075 },
    ]

    const rangoUsados = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 149.99, porcentaje: 0.10 },
        { minimo: 150, maximo: 150000, porcentaje: 0.15 },
    ]


    //TOTALES
    const [totalMaquinaria, setTotalMaquinaria] = useState(0)
    const [totalRefacciones, setTotalRefacciones] = useState(0)
    const [totalServicio, setTotalServicio] = useState(0)
    const [totalPA, setTotalPA] = useState(0)
    const [totalFerreteria, setTotalFerreteria] = useState(0)
    const [totalRiego, setTotalRiego] = useState(0)
    const [totalAMS, setTotalAMS] = useState(0)
    const [totalDrones, setTotalDrones] = useState(0)
    const [totalUsados, setTotalUsados] = useState(0)

    const [totalIncentivo, setTotalIncentivo] = useState(0)


    useEffect(() => {
        let total = 0;

        total = totalMaquinaria + totalRefacciones + totalServicio + totalPA + totalFerreteria + totalRiego + totalAMS + totalDrones + totalUsados;

        setTotalIncentivo(total)

    }, [totalMaquinaria, totalRefacciones, totalServicio, totalPA, totalFerreteria, totalRiego, totalAMS, totalDrones, totalUsados]);

    //INCENTIVO ANUAL
    const rangoAnual = [
        { minimo: 0, maximo: 79.99, porcentaje: 0 },
        { minimo: 80, maximo: 89.99, porcentaje: 1 },
        { minimo: 90, maximo: 99.99, porcentaje: 2 },
        { minimo: 100, maximo: 109.99, porcentaje: 4 },
        { minimo: 110, maximo: 119.99, porcentaje: 5 },
        { minimo: 120, maximo: 150000, porcentaje: 6 },
    ]
    return (
        <>
            <div className="simulador-incentivo-form-seccion-anual-insentive">
                <div className="input-section-container-base-salary">
                    <div className="input-section">
                        <div className="input-section-label">
                            SALARIO BASE
                        </div>

                        <SimuladorNumericInput
                            name="sueldo"
                            label=""
                            value={datos.sueldo}
                            disabled={false}
                            onChange={handleChangeDatos}
                            icono="pesos"
                        />

                    </div>
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <AgricultureIcon /> Maquinaria
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoMaquinaria}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionMaquinaria}
                        setTotal={setTotalMaquinaria}
                        tipoCalculo={'GS'}
                    />
                </div>
                {/* <div className="simulador-incentivo-vendedor-f3">
                    <div className="fila-subtitle">Tractores en paquete</div>
                    <div className="input-section-container-numeric">
                        <div className="input-section">
                            <div className="input-section-label">
                                Número de paquetes del mes (#)
                            </div>
                            <div className="input-section-input">
                                <SimuladorNumericInput
                                    name="paquetes_maquinaria"
                                    label=""
                                    // value={state.paquetes_maquinaria}
                                    disabled={false}
                                    // onChange={handleChange}
                                    icono="none"
                                />
                            </div>
                        </div>
                        <div className="input-section">
                            <div className="input-section-label">Tu incentivo es de:</div>
                            <TextField
                                // label="Nombre"
                                name="IncentivoPaqMaquinaria"
                                value={formData.incentivoPaqMaquinaria}
                                size="small"
                                disabled
                            />
                        </div>
                    </div>
                </div> */}
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BuildIcon sx={{ fontSize: "18px" }} /> Refacciones
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoRefacciones}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionRefacciones}
                        setTotal={setTotalRefacciones}
                        tipoCalculo={'GS'}

                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <CarRepairIcon sx={{ fontSize: "18px" }} /> Servicio
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoServicio}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionServicio}
                        setTotal={setTotalServicio}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <GroupWorkIcon /> Productos Aliados
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoPA}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionPA}
                        setTotal={setTotalPA}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <ConstructionIcon /> Ferreteria
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoFerreteria}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionFerreteria}
                        setTotal={setTotalFerreteria}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <BathroomIcon />  Sistemas de Riego
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoRiego}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionRiego}
                        setTotal={setTotalRiego}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <CellTowerIcon /> AMS
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoAMS}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionAMS}
                        setTotal={setTotalAMS}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <SatelliteAltIcon /> Drones
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoDrones}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionDrones}
                        setTotal={setTotalDrones}
                        tipoCalculo={'GS'}
                    />
                </div>
                <div className="simulador-incentivo-vendedor-f5">
                    <div className="fila-title-b">
                        <StarsIcon /> Seminuevos
                    </div>
                    <SimuladorIncentivosGerenteOR
                        rango={rangoUsados}
                        sueldo={datos.sueldo}
                        ponderacion={datos.ponderacionUsados}
                        setTotal={setTotalUsados}
                        tipoCalculo={'GS'}
                    />
                </div>
            </div>
            <div className="simulador-incentivo-nuevoformat">
                <div className="simulador-incentivo-form-titulos">
                    <span>
                        Considerando los datos ingresados, tu Incentivo total simulado es:
                    </span>
                    <SimuladorNumericInput
                        name="Total"
                        label=""
                        value={totalIncentivo}
                        disabled={true}
                        icono="none"
                        align="centro"
                    />
                </div>
                <div className="simulador-incentivo-form-titulo-leyenda">
                    Este simulador presenta escenarios de compensación estimados con base en los resultados ingresados. Su contenido no representa información oficial ni compromiso de pago
                </div>
            </div>
            <div className="simulador-incentivo-anual-container">
                <div className="fila-title-anual">
                    <CalendarMonthIcon /> Incentivo Anual
                </div>
                <SimuladorIncentivoAnualOR
                    rango={rangoAnual}
                    sueldo={datos.sueldo}
                />
            </div>
        </>
    );
};

export default SimuladorIncentivosGerenteScreen;
